// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2cDPt","modalFooterButton":"ModalNotes_modalFooterButton__okZQ_"};